import React from "react";
import ReactDOM from "react-dom/client";
import App from "./containers/App";
import { HelmetProvider } from "react-helmet-async";
import { CookiesProvider } from "react-cookie";

const helmetContext = {};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <CookiesProvider>
    <HelmetProvider context={helmetContext}>
      <App />
    </HelmetProvider>
  </CookiesProvider>
);
